import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE, ITEMS_PER_PAGE_REPORT_SCHEDULE, PAGE_SIZE_REPORT_SCHEDULE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Input, Row, Select, Space, Switch, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import TableComponent from 'app/shared/component/table/table';
import { enable, getEntities } from '../report-schedule.reducer';
import { columns, yearOptions } from './config';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';

const { Search } = Input;

export const ReportSchedule = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pageLocation = useLocation();
  const { filter } = pageLocation.state || {};

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE_REPORT_SCHEDULE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const reportScheduleList = useAppSelector(state => state.reportSchedule.entities);
  const totalItems = useAppSelector(state => state.reportSchedule.totalItems);

  const [searchText, setSearchText] = useState();
  const [filters, setFilter] = useState<any>(filter);

  // config columns, actions add plan period
  const newColumns = [
    ...columns,
    {
      title: 'Tình trạng',
      key: 'isEnable',
      render: item => (
        <Switch
          checked={item.isEnable}
          onChange={() => {
            handleCloseOrOpen(item);
          }}
          checkedChildren="Mở"
          unCheckedChildren="Đóng"
        />
      ),
    },
    {
      title: 'Hành động',
      key: 'Action',
      fixed: 'right',
      width: 80,
      render: (item: any) => (
        <div className="action">
          <span className="action-edit">
            {true /*(isAdmin || objectivePermissions.Update)*/ && (
              <Tooltip title="Sửa">
                <Link state={{ filter: filters }} to={`/report-schedule/${item.id}`}>
                  <FontAwesomeIcon icon="pencil-alt" />
                </Link>
              </Tooltip>
            )}
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getAllEntities();
  }, [paginationState, filters]);

  const getAllEntities = (value?: string) => {
    dispatch(
      getEntities({
        searchText: value ?? searchText,
        page: value ? 0 : paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        filters,
        year: filters?.year || dayjs().year(),
      }),
    );
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };

  const handleAdd = () => {
    navigate('new');
  };

  const handleCloseOrOpen = item => {
    if (!item.isEnable) {
      dispatch(enable(item.id))
        .then(res => {
          if (res && res.payload) {
            getAllEntities();
          }
        })
        .catch(() => {
          return;
        });
    }
  };

  const handleChangeYear = value => {
    setFilter({ ...filters, year: value });
  }

  return (
    <Container className="view">
      <div className="d-flex gap-5">
        <Title level={3}>Danh sách kỳ báo cáo</Title>
      </div>
      <div className="table">
        <div className="header">
          <Col md={18}>
            <Row>
              <Col md={3}>
                <Select
                  className="w-100"
                  value={filters?.year}
                  showSearch
                  defaultValue={dayjs().year()}
                  options={yearOptions.map(x => {
                    return {
                      value: x,
                      label: x,
                    };
                  })}
                  onChange={handleChangeYear}
                  filterOption={filterOption}
                  placeholder="Chọn năm"
                  size="large"
                />
              </Col>
              <Col md={1} />
              <Col md={12}>
                <Space className="search">
                  <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                </Space>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row className='w-100 justify-content-end'>
              <Col>
                <Space>
                  <Button
                    size="large"
                    onClick={() => {
                      handleAdd();
                    }}
                    className="primary"
                    icon={<PlusOutlined />}
                  >
                    Thêm mới
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
        </div>
        <TableComponent
          data={reportScheduleList.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={false}
          total={totalItems}
          isFetching={false}
          columns={newColumns}
          pageSizeOptions={PAGE_SIZE_REPORT_SCHEDULE}
          perPageOptions={ITEMS_PER_PAGE_REPORT_SCHEDULE}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
    </Container>
  );
};

export default ReportSchedule;
